/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import GeneratorForm from './generator/generator-form';

import template from './app-root.html';

export default {
  name: 'AppRoot',
  template,
  components: {GeneratorForm}
};
